let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6xGS")).then(() => parcelRequire('i2c2s'));